/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:06:11
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-11 10:43:07
 */

import { createApp } from "vue"
import PropertyUI from './property-ui/index.vue'

class Property {
  /**
   * 属性构造函数
   * @param {import('./topology').Topology} topology
   */
  constructor(topology) {
    this.topology = topology
    this.el = topology.dom.propsElem
    this.setup()
  }

  setup() {
    ///////////////////////////////////
    const app = createApp(PropertyUI)
    app.provide('topology', this.topology)
    app.mount(this.el)

    // this.topology.addEventListener('topo:select', (event) => {
    //   this.updatePropertyVisible(event.data)
    // })
  }

  updatePropertyVisible(sel) {
    if (sel == null) {
      this.el.style.width = 0
    } else {
      this.el.style.width = '200px'
    }
  }
}


export { Property }
